import { Component } from '@angular/core';
import { ImplementChallengeComponent } from '../implement-challenge.component';
import { CnAiService } from '../../challenges_service/cn-ai.service';

@Component({
  selector: 'app-implement-challenge-next24',
  templateUrl: './implement-challenge-next24.component.html',
  styleUrls: ['./implement-challenge-next24.component.scss']
})
export class ImplementChallengeNext24Component {

  constructor(public implementChallengeComponent: ImplementChallengeComponent, private aiService: CnAiService) {}

  openAiSidebar() {
    const context = this.implementChallengeComponent?.next_content || [];
    this.aiService.openSidebar(
      'implement', 'next24', context,
      'Generate 5 immediate actions {persona} to take in the next 24 hours. Current context: {context}',
      'next_content', this.implementChallengeComponent
    );
  }
}
